import api from '../Api';
import { BaseService } from '../BaseService';
import { SimulationFinancialsListParams, SimulationFinancialUpdatePayload } from '../../models/SimulationFinancials/SimulationFinancialsModels';

// Listagem e atualização já existem hoje em `simulation/screening/financials`
// (GET pra listar, POST multipart/form-data pra atualizar) — o módulo dedicado
// `simulation_financials` (REST semântico com PATCH) do ticket ainda não existe.
const URL = 'simulation/screening/financials';

export class SimulationFinancialsService extends BaseService {
    async list(params?: SimulationFinancialsListParams): Promise<any[]> {
        try {
            return this.handleResponse(await api.get(URL, { params }));
        } catch (e: any) {
            return this.catchHandler(e);
        }
    }

    async update(payload: SimulationFinancialUpdatePayload): Promise<any[]> {
        try {
            const formData = new FormData();
            formData.append('id', String(payload.id));
            formData.append('name', payload.name);
            formData.append('canonical_id', payload.canonical_id);
            formData.append('is_active', payload.is_active ? 'True' : 'False');
            if (payload.auth_channel) formData.append('auth_channel', payload.auth_channel);
            if (payload.file) formData.append('file', payload.file);

            return this.handleResponse(await api.post(URL, formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            }));
        } catch (e: any) {
            return this.catchHandler(e);
        }
    }
}
